import React from "react";
import { useTranslation } from "react-i18next";
import {
  FaMobileAlt,
  FaWeight,
  FaPhoneVolume,
  FaMotorcycle,
  FaBriefcaseMedical,
  FaAmbulance,
  FaUserInjured
} from "react-icons/fa";
import { BsSmartwatch } from "react-icons/bs";
import "./EsmInnovation.scss";

const EsmExpansion = () => {
  const { t } = useTranslation();

  const nodes = [
    { id: 1, icon: <FaMobileAlt />, label: t("esm_implementation.exp_smartphone") },
    { id: 2, icon: <FaWeight />, label: t("esm_implementation.exp_bmi") },
    { id: 3, icon: <BsSmartwatch />, label: t("esm_implementation.exp_smartwatch") },
    { id: 4, icon: <FaPhoneVolume />, label: t("esm_implementation.exp_247") },
    { id: 5, icon: <FaMotorcycle />, label: t("esm_implementation.exp_delivery") },
    { id: 6, icon: <FaBriefcaseMedical />, label: t("esm_implementation.exp_records") },
    { id: 7, icon: <FaAmbulance />, label: t("esm_implementation.exp_ambulance") },
  ];

  const totalNodes = nodes.length;

  const getLabelClass = (angle) => {
    // Normalizing angle to 0-360
    let a = angle % 360;
    if (a < 0) a += 360;
    
    if (a === 0) return "label-right";
    if (a > 0 && a < 90) return "label-bottom-right";
    if (a === 90) return "label-bottom";
    if (a > 90 && a < 180) return "label-bottom-left";
    if (a === 180) return "label-left";
    if (a > 180 && a < 270) return "label-top-left";
    if (a === 270) return "label-top";
    return "label-top-right"; // 270-360
  };

  return (
    <div className="innov-container">
      <div className="innov-title">
        {t("esm_implementation.expansion_title", "Phát triển, mở rộng dịch vụ phát sinh - Smart Healthcare")}
      </div>

      <div className="innov-canvas">
        {/* The background ring */}
        <div className="innov-ring"></div>

        {/* Center Node (Patient) */}
        <div className="innov-center-node">
          <div className="center-icon">
            <FaUserInjured />
          </div>
          <div className="center-text">{t("esm_implementation.patient")}</div>
        </div>

        {/* Orbiting Nodes */}
        {nodes.map((node, index) => {
          // Calculate angle for positioning. Start at top (270 degrees)
          const angle = (index * 360) / totalNodes - 90;
          const rad = (angle * Math.PI) / 180;
          // Radius of the orbit is 35% of the container
          const R = 35; 
          
          const x = 50 + R * Math.cos(rad);
          const y = 50 + R * Math.sin(rad);

          return (
            <div
              key={node.id}
              className={`innov-node ${getLabelClass(angle)}`}
              style={{
                left: `${x}%`,
                top: `${y}%`,
              }}
            >
              <div className="node-circle">{node.icon}</div>
              <div className="node-label">{node.label}</div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default EsmExpansion;
